<template>
    <div class="container">
      <div class="top">
          <div class="welcome">

          <div class="content">
                    
          </div>
      </div>

      </div>
  <br />&nbsp;<br />
  </div>
</template>
<script>

export default {
  name: 'home',
    data: function() {
      
      return {}
    },
    async mounted() {

      
      this.$router.push('/form/ES_es');
    }
}
</script>